import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

function SocialProofBar() {
  const { t } = useTranslation('static_pages');

  return (
    <StyledBox>
      <SocialProofContent>
        <SocialProofItem>
          <Image
            alt=""
            src="/artifacts/images/marketing_pages/socialProofBar-platform.webp"
            width={54}
            height={54}
          />
          <Box flex={1} px={2} py={{ xs: 2, sm: 2 }}>
            <Typography variant="body1" pr={1}>
              {t('socialProofBar.text1')}
            </Typography>
          </Box>
        </SocialProofItem>

        <SocialProofItem>
          <IconWrapper>
            <Image
              alt=""
              src="/artifacts/images/marketing_pages/socialProofBar-customer.webp"
              width={54}
              height={54}
            />
          </IconWrapper>
          <Box flex={1} px={2} py={{ xs: 2, sm: 2 }}>
            <Typography variant="body1" pr={{ xs: 0, md: 1.5 }}>
              {t('socialProofBar.text2')}
            </Typography>
          </Box>
        </SocialProofItem>

        <SocialProofItem>
          <IconWrapper>
            <Image
              alt=""
              src="/artifacts/images/marketing_pages/socialProofBar-partner.webp"
              width={54}
              height={54}
            />
          </IconWrapper>

          <Box flex={1} px={2} py={{ xs: 4, sm: 2 }}>
            <Typography variant="body1" pr={{ xs: 1, md: 3 }}>
              {t('socialProofBar.text3')}
            </Typography>
          </Box>
        </SocialProofItem>

        <SocialProofItem>
          <IconWrapper>
            <Image
              alt=""
              src="/artifacts/images/marketing_pages/socialProofBar-stars.webp"
              width={54}
              height={54}
            />
          </IconWrapper>
          <Box flex={1} px={2} py={{ xs: 2, sm: 2 }}>
            <Typography variant="body1" pr={1}>
              {t('socialProofBar.text4')}
            </Typography>
          </Box>
        </SocialProofItem>
      </SocialProofContent>
    </StyledBox>
  );
}

function IconWrapper({ children }) {
  return <Box>{children}</Box>;
}

const SocialProofContent = styled.div`
  display: flex;
  justify-content: space-around;
  ${(props) => props.theme.breakpoints.down('xs')} {
    flex-direction: column;
  }
`;

const StyledBox = styled.div`
  background-color: #f8f8f8;
  padding: ${(props) => props.theme.spacing(1.5, 3, 1, 8)};

  ${(props) => props.theme.breakpoints.down('sm')} {
    padding: ${(props) => props.theme.spacing(2, 0, 2, 3)};
  }
`;

const SocialProofItem = styled.div`
  display: flex;
  align-items: center;
  width: 21%;

  ${(props) => props.theme.breakpoints.down('sm')} {
    width: 33%;
  }

  ${(props) => props.theme.breakpoints.down('xs')} {
    width: 100%;
    display: flex;
  }
`;

export default SocialProofBar;
